import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private endpointPrefix = '';

  setEndpointPrefix(endpointPrefix: string): void {
    this.endpointPrefix = endpointPrefix;
  }

  getEndpointFor(api: string, microservice?: string): string {
    let apiPath = api;
    if (apiPath.startsWith('/')) {
      apiPath = apiPath.substring(1);
    }
    let endpoint = `${this.endpointPrefix}/${apiPath}`;
    if (microservice) {
      endpoint = `${this.endpointPrefix}/services/${microservice}/${apiPath}`;
    }
    return endpoint.replace(/([^:]\/)\/+/g, '$1');
  }
}
